'use client'
import React from 'react'

export const ChecklistIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="icon"
    fill="none"
    focusable="false"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect height="13" rx="1.5" stroke="currentColor" width="13" x="3.5" y="3.5" />
    <path d="M7 10L9 12.5L13 7.5" stroke="currentColor" strokeWidth="1.5" />
  </svg>
)
